import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../../../../../environments/environment.prod";

@Component({
	selector: "kt-static-list",
	templateUrl: "./static-list.component.html",
	styleUrls: ["./static-list.component.scss"],
})
export class StaticListComponent implements OnInit {
	title = "";
	items: string[] = [];

	constructor(private route: ActivatedRoute) {}

	ngOnInit() {
		this.route.data.subscribe((data) => {
			this.title = data.staticList.title;
			this.items = (environment as any)[data.staticList.key] || [];
		});
	}
}
